import { StyleSheet } from 'aphrodite';
import { SPACE } from '../../web/components-v2/Theme/theme';
import { header, urgentDate } from '../../web/styles/colors';
import { CssSelectors } from '../../web/styles/styles';
import { styleSheet as pageStyles } from '../styles/styles';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[4],
		...CssSelectors.allChildren(
			{
				paddingTop: 0,
			},
			'button'
		),
	},
	error: {
		color: urgentDate,
		fontSize: 12,
		fontStyle: 'italic',
	},
	meetingGuest: {
		color: header,
		display: 'flex',
		fontStyle: 'italic',
		justifyContent: 'flex-start',
		...CssSelectors.allChildren(
			{
				maxWidth: 20,
				paddingTop: 0,
			},
			'button'
		),
	},
	meetingGuestsContainer: {
		marginBottom: SPACE[8],
		maxHeight: 100,
		overflow: 'auto',
	},
	text: {
		...pageStyles.text,
		fontSize: 14,
		paddingBottom: SPACE[4],
	},
});
